import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Wager } from "../types";

interface ResolveWagerModalProps {
  wager: Wager;
  onSubmit: Function;
  show: boolean;
  onClose: Function;
}

export default function ResolveWagerModal(props: ResolveWagerModalProps) {
  const [wagerOutcome, setWagerOutcome] = useState(0);

  return (
    <Modal show={props.show} onHide={() => props.onClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Place bet</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Select
          aria-label="Default select example"
          onChange={(e) => setWagerOutcome(Number(e.currentTarget.value))}
        >
          <option>Select an outcome</option>
          {props.wager.outcomes.map((outcome, index) => (
            <option key={index} value={index}>
              {outcome}
            </option>
          ))}
        </Form.Select>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.onClose()}>
          Close
        </Button>
        <Button variant="primary" onClick={() => props.onSubmit(wagerOutcome)}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
